<p>timecard-record works!</p>
